/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Row, Col, Spin } from 'antd';

import { useModalControls } from '@hooks';
import { Button, Typography } from '@atoms';
import { FULL_WIDTH } from '@constants';
import { useMedia } from '@api/hooks';
import { MEDIA_TYPE, IMAGE_SIZE } from '@api/media/constants';
import { getTypeName, decodeCrop } from '@utils/media';
import AddMediaModal from '@organisms/AddMediaModal';

const getDefaultButtonText = (type) => `CHOOSE A NEW ${getTypeName(type).toUpperCase()}`;

const MediaSelect = ({
  value,
  onChange,
  disabled,
  hideTitle,
  shouldSkipCorp,
  onButtonClicked,
  size = IMAGE_SIZE['600x400'],
  type = MEDIA_TYPE.IMAGE,
  buttonText = getDefaultButtonText(type),
  handlerTitle = null,
  ...props
}) => {
  const modal = useModalControls();

  const { data: media, error, ...mediaQuery } = useMedia(value);
  const initialCrop = React.useMemo(() => decodeCrop(value?.edited)?.edits?.extract, [value]);
  const typeName = getTypeName(type);
  const title = error ? `Error loading ${typeName}` : media?.title || `No ${typeName}`;


  React.useEffect(() => {
    if (handlerTitle) {
      handlerTitle(title);
    }
  }, [handlerTitle, title]);

  return (
    <>
      <Spin spinning={mediaQuery.isFetching}>
        <Row gutter={10} align="middle">
          {media?.src && (
            <Col>
              <img style={{ maxHeight: 30, width: 'auto' }} src={media.src} alt="" />
            </Col>
          )}
          <Col style={{ minWidth: 0 }} flex="1">
            <Typography.Text ellipsis style={FULL_WIDTH}>
            {hideTitle ? '' : title}
            </Typography.Text>
          </Col>
          <Col>
            <Button disabled={disabled} onClick={() => { modal.show(); if(onButtonClicked !== undefined && onButtonClicked !== null){ onButtonClicked();}}}>
              {buttonText}
            </Button>
          </Col>
        </Row>
      </Spin>
      <AddMediaModal
        {...props}
        {...modal}
        size={size}
        initialMedia={media}
        skipCrop={shouldSkipCorp ? shouldSkipCorp : undefined}
        initialCrop={initialCrop}
        onAddMedia={onChange}
        type={type}
      />
    </>
  );
};

export default MediaSelect;
